
import * as Sentry from '@sentry/browser';


Sentry.init({
  dsn: "https://2167231570d74901b73bddb0cebf0be8@sentry.io/6536",
  
  release: '99ab22f7ab58c3969763d49e17df1aab8005ab9f',
  
  linesOfContext: 500, 
  integrations: (defaultIntegrations) => {
    //  disable sessions and session tracking
    return defaultIntegrations.filter(
      (integration) => integration.name !== "BrowserSession",
    );
  },
  environment: 'production',
  ignoreErrors: [ 'DOMException: WRONG_DOCUMENT_ERR', 'Non-Error promise rejection captured', 'EvalError' ]
});


window.Sentry = Sentry

